import { i18nMark } from 'lingui-react';

const messages = {
  address: i18nMark('Address'),
  closed: i18nMark('Closed'),
  friday: i18nMark('Fri'),
  hours: i18nMark('Hours'),
  monday: i18nMark('Mon'),
  noHoursAvailable: i18nMark('Not Provided'),
  open: i18nMark('Open'),
  phone: i18nMark('Phone'),
  saturday: i18nMark('Sat'),
  sunday: i18nMark('Sun'),
  thursday: i18nMark('Thu'),
  title: i18nMark('Service Provider'),
  tuesday: i18nMark('Tue'),
  wednesday: i18nMark('Wed'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/ServiceProviderWidget/messages.js